import { useDispatch, useSelector } from "react-redux";
import { Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

import { FULL_DAYS } from "../../../consts/strings";

import { setUnlockDriversDayModalOpen } from "../../../reducers/ownApp";
import { unlockDriversDayModalOpenSelector } from "../../../reducers/ownApp/selectors";
import { forceUnlockDriversDay } from "../../../reducers/matrixProfile/thunkActions";
import { getSelectedPlanDay } from "../../../reducers/matrixProfile/selectors";

import { Modal } from "../Modal";
import { UnlockDriversDayModalActions } from "./UnlockDriversDayModalActions";

const useStyles = makeStyles({
  text: {
    fontSize: "16px",
    lineHeight: "20px",
    marginTop: "10px",
  },
});

const UnlockDriversDayModal = () => {
  const dispatch = useDispatch();

  const classes = useStyles();
  const modalOpen = useSelector(unlockDriversDayModalOpenSelector);
  const dayOfWeek = useSelector(getSelectedPlanDay);

  const closeClick = () => {
    dispatch(setUnlockDriversDayModalOpen(false));
  };

  const continueCLick = () => {
    dispatch(setUnlockDriversDayModalOpen(false));
    dispatch(forceUnlockDriversDay());
  };

  return (
    <>
      <Modal
        maxWidth={"xs"}
        open={modalOpen}
        onClose={closeClick}
        title={`Unlock ${FULL_DAYS[dayOfWeek]} Drivers`}
        content={
          <>
            <Typography className={classes.text}>
              Are you sure you wish to unlock all {FULL_DAYS[dayOfWeek]} drivers
              in the selected depot?
            </Typography>
            <Typography className={classes.text}>
              If you continue, this will remove the locks from all{" "}
              {FULL_DAYS[dayOfWeek]} Driver records in this depot and these
              users will lose any unsaved Driver changes.
            </Typography>
          </>
        }
        actions={
          <UnlockDriversDayModalActions
            onCancel={closeClick}
            onContinue={continueCLick}
          />
        }
        minWidth={500}
      />
    </>
  );
};

export default UnlockDriversDayModal;
